export default {
  en: {
    ACTION_EXPORT_CSV: 'Export CSV',

    ALERT_INVITE_SUCCESS: 'User has been created and sent an invite.',

    ACCOUNT_USER_BUYER_ROLE: 'Buyer',
    ACCOUNT_USER_PUBLISHER_ROLE: 'Publisher',
    ACCOUNT_USER_BUYER_MANAGER_ROLE: 'Buyer Manager',
    ACCOUNT_USER_PUBLISHER_MANAGER_ROLE: 'Publisher Manager',
    ACCOUNT_USER_REPORT_ROLE: 'Report Access',
    ACCOUNT_USER_ADMIN_ROLE: 'Admin',

    USERS_TABLE_LOADING: 'Loading users',
    USERS_TABLE_EMPTY: 'You have not created any users.',
    
    ACTION_INVITE: 'Invite User',
    TABLE_HEADER_COL_NAME: 'Name',
    TABLE_HEADER_COL_EMAIL: 'Email',
    TABLE_HEADER_COL_ROLE: 'Role',
    TABLE_HEADER_COL_INVITATION: 'Invitation',
    TABLE_HEADER_COL_CAN_EXPORT: 'Can Export Reports',

    TT_ACTION_REMOVE_INVITATION: 'Remove invitation',
    MESSAGE_REMOVE_INVITATION_SUCCESSFUL: 'Invitation has been removed.',
    TT_ACTION_REMOVE_USER: 'Remove user',
    MESSAGE_REMOVE_USER_SUCCESSFUL: 'User has been removed.',
    TT_ACTION_COPY_INVITE: 'Copy invitation URL',
    MESSAGE_COPY_INVITE_URL_SUCCESS: 'Invitation URL is now in your clipboard',
    ACTION_CREATE_INVITE: 'Invite user',
    
    INPUT_LABEL_FIRST_NAME: 'First Name',
    TT_FIRST_NAME: 'Enter user\'s first name.',
    INPUT_LABEL_LAST_NAME: 'Last Name',
    TT_LAST_NAME: 'Enter user\'s last name.',
    INPUT_LABEL_EMAIL: 'Email Address',
    TT_EMAIL: 'Enter user\'s email address to be used to login Ringba.',
    INVALID_EMAIL_LABEL: 'This is not a valid email',
    INPUT_LABEL_CONFIRM_EMAIL: 'Confirm Email',
    TT_CONFIRM_EMAIL: 'Confirm user\'s email address.',
    INVALID_CONFIRM_EMAIL_LABEL: 'This does not match the above email address',
    INPUT_LABEL_ROLE: 'Role',    
    TT_ROLE: 'This will set the access level of the user.',
    INPUT_LABEL_CAN_EXPORT: 'Can Export Reports',
    TT_CAN_EXPORT: 'Enable to allow this Report Access user to export their reports.',
    INVALID_FORM: 'Please fill out required or invalid fields and try again',

    TITLE_DELETE_INVITE: 'Confirm Remove Invitation',
    LABEL_DELETE_INVITE_MODAL_MESSAGE: 'Are you sure you want to cancel and remove an invitation for {userName}?',
    LABEL2_DELETE_INVITE_MODAL_MESSAGE: 'User will not be able to join the platform via this invitation anymore.',
    TITLE_DELETE_USER: 'Confirm Remove User',
    LABEL_DELETE_USER_MODAL_MESSAGE: 'Are you sure you want to remove {userName}?',
    MENU_LEFT_MANAGE_USERS: 'Manage Users',
    PLACEHOLDER_USERS_SEARCH: 'Search Users'
  }
};